import React from 'react';

import { LoomIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <LoomIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useLoom = (fallbackUrl: FallbackUrl, options: GlobalShortcutConfiguration = {}) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.LOOM,
		analyticsName: Products.LOOM,
		...options,
	});
